import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    
    endpoint = environment.APIEndpoint
    constructor(private httpClient: HttpClient,private loadingController: LoadingController) { }

    //Used to create information
    async post(url, in_data) {
        if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
        console.log("POST: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .post(this.endpoint + url, in_data, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if(!error_data.message) error_data.message = "Something went wrong";
                    resolve(error_data)
                })
        })
    }

    //Used to get information
    async get(url) {
        if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
        console.log("GET: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .get(this.endpoint + url, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if(!error_data.message) error_data.message = "Something went wrong";
                        
                    resolve(error_data)
                })
        })
    }

    //Generally used to make an update
    async put(url, in_data) {
        if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
        console.log("PUT: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .put(this.endpoint + url, in_data, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if(!error_data.message) error_data.message = "Something went wrong";
                    resolve(error_data)
                })
        })
    }

    //Used to delete a resource
    async delete(url,in_data) {
        if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
        console.log("DELETED: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .delete(this.endpoint + url, {
                    withCredentials: true,
                    body: in_data
                })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if(!error_data.message) error_data.message = "Something went wrong";
                    resolve(error_data)
                })
        })
    }


        //Download a file
        async DownloadFile(file) {
            if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
            window.open(`${this.endpoint}files/download/${file.guid}`,'_blank');
        }
        GetDownloadURL(file) {
            if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
            return `${this.endpoint}files/download/${file.guid}`;
        }
        async DownloadAsZip(guid_array) {
            if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
            let guid_string = guid_array.join("~");
            window.open(`${this.endpoint}files/download/zip/${guid_string}`,'_blank');
        }

        async DownloadFilePost(data, file) {
            if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
            // Set options, including responseType to 'blob' for file download
            const httpOptions = {
                headers: new HttpHeaders({
                    // Set any necessary headers here
                }),
                responseType: 'blob' as 'json'  // Cast responseType to 'blob' to tell HttpClient to expect a binary response
            };
    
            // Send the POST request with data to the server and expect a file in response
            this.httpClient.post(`${this.endpoint}public/email/files/${file.guid}`, data, httpOptions).subscribe(
                (response: any) => {
                    // Create a URL for the file
                    const blob: Blob = new Blob([response], { type: 'application/octet-stream' });
                    const downloadUrl = window.URL.createObjectURL(blob);
    
                    // Create a link to download it
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = file.file_name;  // Set the file name here
                    link.click();
    
                    // Clean up by revoking the object URL
                    window.URL.revokeObjectURL(downloadUrl);
                },
                error => {
                    console.log('Error downloading the file.');
                    // Handle any errors encountered during download
                }
            );
        }

        async GenerateSurveyPDF(guid) {
            if(!window.location.hostname.includes("localhost")) this.endpoint = environment.APIEndpointPROD;
            window.open(`${this.endpoint}surveys/pdf/${guid}`,'_blank');
        }

}
